import script from "./PatientAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PatientAvatar.vue?vue&type=style&index=0&id=5c63aaa0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c63aaa0"]])

export default __exports__